import { TempArquivo } from "./typings";
import { AxiosError, AxiosResponse } from "axios";
import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { useMutation } from "react-query";

function useUploadAnexo() {
  return useMutation<AxiosResponse<TempArquivo>, AxiosError<any>, File, any>(
    async (file: File) => {
      const formData = new FormData();
      formData.append("file", file);
      return await http.post(`/v1/arquivos/upload-anexos`, formData);
    },
    {
      retry: false,
      onError: (e) => {
        showErrorAxios(e);
      },
      mutationKey: "upload-anexos",
    }
  );
}

export default useUploadAnexo;
